import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";

export default function view() {
  const $this = this;
  const { $inputs } = this;

  return (view = ViewFactory({
    NAME: 'MOMO_FRANCO_CONFIRM_VIEW',
    constants: {
      get instruction() { return $this.CONFIRM_INSTRUCTION },
      get phone() { return getValueAtPath($inputs, '[phone].value') },
      get selectedNetwork() { return getValueAtPath($inputs, '[network].value') }
    }
  }).call(this));
}
